import { CardFooter } from "./CardFooter";

export { CardFooter };
